import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '@avenir-client-web/base-control';
import { MaxLengthModule } from '@avenir-client-web/max-length';
import { InputTextModule } from 'primeng/inputtext';

type InputType = 'text' | 'number' | 'password' | 'email';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, InputTextModule, MaxLengthModule, FormsModule],
})
export class InputComponent extends BaseControlComponent<string> {
  @Input() maxLength: number;

  @Input() type: InputType = 'text';

  @Input() autoTrim = true;

  @ViewChild('input', { static: true }) input: ElementRef;

  onBlur(): void {
    if (this.autoTrim) {
      this.onValueChange(this.value?.trim());
    }
  }
}
